<template>
  <div id="terms" class="row reverse-mobile">
    <div class="col-12 terms">
      <div class="row">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title">Terms and Conditions of iSimulate</h3>
            <div class="col-12">
              <p>
                These terms and conditions are the contract between you and
                iSimulate (&ldquo;us&rdquo;, &ldquo;we&rdquo;, etc). By visiting
                or using Our Website, you agree to be bound by them.
              </p>
              <p>
                We are iSimulate Pty Ltd, a company registered in Australia, ABN
                13 154 034 214
              </p>
              <p>
                Our address is: G8/45 Honeysett View, Kingston ACT 2604
                Australia .
              </p>
              <p>You are: Anyone who uses Our Website.</p>
              <p>
                Please read this agreement carefully and save it. If you do not
                agree with it, you should leave Our Website immediately.
              </p>
              <p>
                <strong>These are the agreed terms</strong>
              </p>
              <ol>
                <li>
                  <strong>Definitions</strong>
                </li>
              </ol>
              <table cellspacing="0" cellpadding="0">
                <tbody>
                  <tr>
                    <td valign="top">
                      <p>&ldquo;Content&rdquo;</p>
                    </td>
                    <td valign="top">
                      <p>
                        means the textual, visual or aural content that is
                        encountered as part of your experience on Our Website.
                        It may include, among other things: text, images,
                        sounds, videos and animations. It includes content
                        Posted by you.
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <p>"Intellectual Property"</p>
                    </td>
                    <td valign="top">
                      <p>
                        means intellectual property owned by us, of every sort,
                        whether or not registered or registrable in any country,
                        including intellectual property of kinds coming into
                        existence after today; and including, among others,
                        patents, trademarks, unregistered marks, designs,
                        copyrights, software, domain names, discoveries,
                        creations and inventions, together with all rights which
                        are derived from those rights.
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <p>&ldquo;Our Website&rdquo;</p>
                    </td>
                    <td valign="top">
                      <p>
                        means any website or service designed for electronic
                        access by mobile or fixed devices which is owned or
                        operated by us or any member of the iSimulate group of
                        companies. It includes all web pages controlled by
                        us.&nbsp;
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <p>"Post"</p>
                    </td>
                    <td valign="top">
                      <p>
                        means place on or into Our Website any Content or
                        material of any sort by any means.
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <p>&ldquo;Services&rdquo;</p>
                    </td>
                    <td valign="top">
                      <p>
                        means all of the services available from Our Website,
                        whether free or charged.
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <p>&ldquo;Visitor&rdquo;</p>
                    </td>
                    <td valign="top">
                      <p>means anyone who visits Our Website.</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <ol start="2">
                <li>
                  <strong>Interpretation</strong>
                </li>
              </ol>
              <p>In this agreement unless the context otherwise requires:</p>
              <ol>
                <ol>
                  <li>
                    a reference to a person includes a human individual, a
                    corporate entity and any organisation which is managed or
                    controlled as a unit.
                  </li>
                  <li>
                    a reference to a person includes reference to that
                    person&rsquo;s successors, legal representatives, permitted
                    assigns and any person to whom rights and obligations are
                    transferred or pass as a result of a merger, division,
                    reconstruction or other re-organisation involving that
                    person.
                  </li>
                  <li>
                    in the context of permission, &ldquo;may not&rdquo; in
                    connection with an action of yours, means &ldquo;must
                    not&rdquo;.
                  </li>
                  <li>
                    the headings to the paragraphs and schedules (if any) to
                    this agreement are inserted for convenience only and do not
                    affect the interpretation.
                  </li>
                  <li>
                    any agreement by either party not to do or omit to do
                    something includes an obligation not to allow some other
                    person to do or omit to do that same thing.
                  </li>
                  <li>
                    a reference to an act or regulation includes new law of
                    substantially the same intent as the act or regulation
                    referred to.
                  </li>
                  <li>
                    this agreement is made only in the English language. If
                    there is any conflict in meaning between the English
                    language version of this agreement and any version or
                    translation of this agreement in any other language, the
                    English language version shall prevail.
                  </li>
                </ol>
                <li>
                  <strong>Basis of Contract</strong>
                </li>
                <ol>
                  <li>
                    We do not offer the Services in all countries. We may refuse
                    to provide the Services if you live in a country we do not
                    serve.
                  </li>
                  <li>
                    In entering into this contract you have not relied on any
                    representation or information from any source except the
                    definition and explanation of the Services given on Our
                    Website.
                  </li>
                  <li>
                    Subject to these terms and conditions, we agree to provide
                    to you some or all of the Services described on Our Website
                    at the prices we charge from time to time.
                  </li>
                  <li>
                    Some of our Services are now or may in future, be available
                    to you only subject to additional terms. Those terms will be
                    set out on Our Website. You now agree that if you choose to
                    use any such service, the relevant terms will become part of
                    this agreement.&nbsp;
                  </li>
                  <li>
                    You acknowledge that you understand exactly what is included
                    in the Services and you are satisfied that the Services are
                    suitable and satisfactory for your requirements;&nbsp;
                  </li>
                  <li>
                    So far as we allow use of our Intellectual Property, we
                    grant a licence to you, limited to the terms set out in this
                    agreement.
                  </li>
                  <li>
                    Our contract with you and licence to you last from the date
                    of payment. Any continuation by us or by you after the
                    expiry of your designated paid service contract is a new
                    contract under the terms then posted on Our Website. Your
                    continued use of our Services after that shall be deemed
                    acceptance by you of the changed Service, system and/or
                    terms.
                  </li>
                  <li>
                    The contract between us comes into existence when we receive
                    payment from you for a Service.
                  </li>
                  <li>
                    If we give you free access to a Service or feature on Our
                    Website which is normally a charged feature, and that
                    Service or feature is usually subject to additional
                    contractual terms, you now agree that you will abide by
                    those terms.&nbsp;
                  </li>
                  <li>
                    We may change this agreement and / or the way we provide the
                    Services, at any time. If we do:
                  </li>
                  <ol>
                    <li>
                      The change will take effect when we Post it on Our
                      Website.
                    </li>
                    <li>
                      You agree to be bound by any changes. If you do not agree
                      to be bound by them, you should not use Our Website or the
                      Services.
                    </li>
                    <li>
                      If you make any payment for Services in the future, you
                      will do so under the terms Posted on Our Website at that
                      time.
                    </li>
                  </ol>
                </ol>
                <li>
                  <strong>Your account and personal information</strong>
                </li>
                <ol>
                  <li>
                    When you visit Our Website, you accept responsibility for
                    any action done by any person using your name, account or
                    password. You should take all necessary steps to ensure that
                    the password is kept confidential and secure and should
                    inform us immediately if you have any reason to believe that
                    your password has become known to anyone else, or if the
                    password is being, or is likely to be, used in an
                    unauthorised manner.
                  </li>
                  <li>
                    You agree that you have provided accurate, up to date, and
                    complete information about yourself. We are not responsible
                    for any error made as a result of such information being
                    inaccurate.
                  </li>
                  <li>
                    You agree to notify us of any changes in your information
                    immediately it occurs. If you do not do so, we may terminate
                    your account.
                  </li>
                </ol>
                <li>
                  <strong>iSimulate subscription terms</strong>
                </li>
                <ol>
                  <li>
                    Details of the cost and benefits of iSimulate subscription
                    are as set out on Our Website and accordingly updated from
                    time to time.
                  </li>
                  <li>
                    Payment for an iSimulate subscription is for the length of
                    time specified in your invoice.&nbsp;
                  </li>
                  <li>
                    Termination of iSimulate subscription will be regulated by
                    this contract set out in paragraph 15 below.
                  </li>
                  <li>
                    We reserve the right to modify the iSimulate subscription
                    rules or system and to change the terms and conditions of
                    this agreement at any time, without notice. Your continued
                    use of the iSimulate Service after such modifications shall
                    be deemed an acceptance by you to be bound by the terms of
                    the modified agreement. The terms that apply to you are
                    those Posted here on Our Website on the day you subscribe to
                    Our Website.&nbsp;
                  </li>
                </ol>
                <li>
                  <strong>The price</strong>
                </li>
                <ol>
                  <li>
                    The prices payable for Services are clearly set out in your
                    invoice.
                  </li>
                  <li>
                    The price charged for any Services may differ from one
                    country to another. You may not be entitled to the lowest
                    price unless you reside in the qualifying country.
                  </li>
                  <li>
                    Prices are inclusive of any applicable goods and services
                    tax or other sales tax.
                  </li>
                  <li>
                    When you subscribe for a subscription Service, that payment
                    may not cover other Services, for which we will ask you to
                    pay either by addition to your subscription or by a single
                    payment.
                  </li>
                </ol>
                <li>
                  <strong>Renewal payments for annual subscriptions</strong>
                </li>
                <ol>
                  <li>
                    At least four weeks before expiry of the period, for which
                    you have paid, we shall send you a message to your last
                    known email address to tell you that your subscription and
                    licence to use the Services is shortly to expire and to
                    invite you to renew. An invoice for the new period will be
                    included.
                  </li>
                  <li>
                    At expiry of your iSimulate subscription we shall send you
                    an invoice with the sum specified.&nbsp;
                  </li>
                  <li>
                    Subject to last previous sub-paragraph, you may cancel
                    subscription within 15 days after the day we confirm the
                    renewal of your iSimulate subscription. If you do so we will
                    refund your subscription cost within 15 days of receipt of
                    this request.
                  </li>
                  <li>
                    Other than the limitation set out above iSimulate
                    subscription is non-refundable and non-transferable.&nbsp;
                  </li>
                </ol>
                <li>
                  <strong>Security of your credit card</strong>
                </li>
              </ol>
              <p>We take care to make Our Website safe for you to use.</p>
              <ol>
                <ol>
                  <li>
                    Card payments are not processed on a page controlled by us.
                    We use one or more online payment service providers who will
                    encrypt your card or bank account details in a secure
                    environment.
                  </li>
                  <li>
                    If you have asked us to remember your credit card details
                    for your next purchase or subscription, we will securely
                    store your payment details on our systems. These details
                    will be fully encrypted and only used to process your
                    automatic monthly payments or other transactions which you
                    have initiated.
                  </li>
                </ol>
                <li>
                  <strong>How we handle your Content</strong>
                </li>
                <ol>
                  <li>
                    Our privacy policy is strong and precise. It complies fully
                    with current privacy law which is at
                    <a href="/privacy">Privacy Policy</a>.
                  </li>
                  <li>
                    If you Post Content to any public area of Our Website it
                    becomes available in the public domain. We have no control
                    over who sees it or what anyone does with it.
                  </li>
                  <li>
                    Even if access to your text is behind a user registration it
                    remains effectively in the public domain because someone has
                    only to register and log in, to access it. You should
                    therefore avoid Posting unnecessary confidential
                    information.
                  </li>
                  <li>
                    We need the freedom to be able to publicise our Services and
                    your own use of them. You therefore now irrevocably grant us
                    the right and licence to edit, copy, publish, distribute,
                    translate and otherwise use any Content that you place on
                    Our Website, in public domains and in any medium. You
                    represent and warrant that you are authorised to grant all
                    such rights.
                  </li>
                  <li>
                    We will use that licence only for commercial purposes of the
                    business of Our Website and will stop using it after a
                    commercially reasonable period of time.
                  </li>
                  <li>
                    You agree to any act or omission which may otherwise
                    infringe your right to be identified as the author and your
                    right to object to derogatory treatment of your work as
                    provided in the Copyright Act 1968.
                  </li>
                  <li>
                    You now irrevocably authorise us to publish feedback,
                    comments and ratings about your activity through Our
                    Website, even though it may be defamatory or critical.
                  </li>
                  <li>
                    Posting content of any sort does not change your ownership
                    of the copyright in it. We have no claim over it and we will
                    not protect your rights for you.
                  </li>
                  <li>
                    You understand that you are personally responsible for your
                    breach of someone else&rsquo;s intellectual property rights,
                    defamation, or any law, which may occur as a result of any
                    Content having been Posted by you.
                  </li>
                  <li>
                    You accept all risk and responsibility for determining
                    whether any Content is in the public domain and not
                    confidential.
                  </li>
                  <li>
                    Please notify us of any security breach or unauthorised use
                    of your account.
                  </li>
                  <li>
                    We do not solicit ideas or text for improvement of our
                    Service, but if you do send to us material of any sort, you
                    are deemed to have granted to us a licence to use it in the
                    terms set out at sub paragraph five above.
                  </li>
                </ol>
                <li>
                  <strong
                    >Restrictions on what you may Post to Our Website</strong
                  >
                </li>
              </ol>
              <p>
                We invite you to Post Content to Our Website in several ways and
                for different purposes. We have to regulate your use of Our
                Website to protect our business and our staff, to protect other
                users of Our Website and to comply with the law. These
                provisions apply to all users of Our Website.
              </p>
              <p>
                We do not undertake to moderate or check every item Posted, but
                we do protect our business vigorously. If we believe Content
                Posted breaches the law, we shall co-operate fully with the law
                enforcement authorities in whatever way we can.&nbsp;
              </p>
              <p>
                You agree that you will not use or allow anyone else to use Our
                Website to Post Content or undertake any activity which is or
                may:
              </p>
              <ol>
                <ol>
                  <li>
                    be unlawful, or tend to incite another person to commit a
                    crime;
                  </li>
                  <li>consist in commercial audio, video or music files;</li>
                  <li>
                    be obscene, offensive, threatening, violent, malicious or
                    defamatory;
                  </li>
                  <li>be sexually explicit or pornographic;</li>
                  <li>
                    be likely to deceive any person or be used to impersonate
                    any person, or to misrepresent your identity, age or
                    affiliation with any person;
                  </li>
                  <li>
                    request or collect passwords or other personal information
                    from another user without his permission, nor Post any
                    unnecessary personal information about yourself;
                  </li>
                  <li>
                    be used to sell any goods or services or for any other
                    commercial use not intended by us, for yourself or for any
                    other person. Examples are: sending private messages with a
                    commercial purpose, or collecting information with the
                    intention of passing it to a third party for his commercial
                    use;
                  </li>
                  <li>
                    facilitate the provision of unauthorised copies of another
                    person's copyright work;
                  </li>
                  <li>
                    link to any of the material specified in this paragraph;
                  </li>
                  <li>
                    Post excessive or repeated off-topic messages to any forum
                    or group;
                  </li>
                  <li>
                    sending age-inappropriate communications or Content to
                    anyone under the age of 18.
                  </li>
                </ol>
                <li>
                  <strong>Your Posting: restricted content</strong>
                </li>
              </ol>
              <p>
                In connection with the restrictions set out below, we may refuse
                or edit or remove a Posting which does not comply with these
                terms.
              </p>
              <p>
                In addition to the restrictions set out above, a Posting must
                not contain:
              </p>
              <ol>
                <ol>
                  <li>
                    hyperlinks, other than those specifically authorized by us;
                  </li>
                  <li>
                    keywords or words repeated, which are irrelevant to the
                    Content Posted.
                  </li>
                  <li>
                    the name, logo or trademark of any organisation other than
                    that of you or your client.
                  </li>
                  <li>inaccurate, false, or misleading information.</li>
                </ol>
                <li>
                  <strong>Removal of offensive Content</strong>
                </li>
                <ol>
                  <li>
                    For the avoidance of doubt, this paragraph is addressed to
                    any person who comes on Our Website for any purpose.
                  </li>
                  <li>
                    We are under no obligation to monitor or record the activity
                    of any Visitor or customer for any purpose, nor do we assume
                    any responsibility to monitor or police Internet-related
                    activities. However, we may do so without notice to you and
                    without giving you a reason.
                  </li>
                  <li>
                    If you are offended by any Content, the following procedure
                    applies:
                  </li>
                  <ol>
                    <li>
                      Your claim or complaint must be submitted to us in the
                      form available on Our Website, or contain the same
                      information as that requested in our form. It must be sent
                      to us by post or email.
                    </li>
                    <li>
                      we shall remove the offending Content as soon as we are
                      reasonably able;
                    </li>
                    <li>
                      after we receive notice of a claim or complaint, we shall
                      investigate so far as we alone decide;
                    </li>
                    <li>
                      we may re-instate the Content about which you have
                      complained or not.
                    </li>
                  </ol>
                  <li>
                    In respect of any complaint made by you or any person on
                    your behalf, whether using our form of complaint or not, you
                    now irrevocably grant to us a licence to publish the
                    complaint and all ensuing correspondence and communication,
                    without limit.
                  </li>
                  <li>
                    You now agree that if any complaint is made by you
                    frivolously or vexatiously you will repay us the cost of our
                    investigation including legal fees, if any.
                  </li>
                </ol>
                <li>
                  <strong>Security of Our Website</strong>
                </li>
              </ol>
              <p>
                If you violate Our Website we shall take legal action against
                you.
              </p>
              <p>
                You now agree that you will not, and will not allow any other
                person to:
              </p>
              <ol>
                <ol>
                  <li>
                    modify, copy, or cause damage or unintended effect to any
                    portion of Our Website, or any software used within it.
                  </li>
                  <li>
                    link to Our Website in any way that would cause the
                    appearance or presentation of Our Website to be different
                    from what would be seen by a user who accessed Our Website
                    by typing the URL into a standard browser;
                  </li>
                  <li>
                    download any part of Our Website, without our express
                    written consent;
                  </li>
                  <li>
                    collect or use any product or service listings,
                    descriptions, or prices;
                  </li>
                  <li>
                    collect or use any information obtained from or about Our
                    Website or the Content except as intended by this agreement;
                  </li>
                  <li>
                    aggregate, copy or duplicate in any manner any of the
                    Content or information available from Our Website, other
                    than as permitted by this agreement or as is reasonably
                    necessary for your use of the Services;
                  </li>
                  <li>
                    share with a third party any login credentials to Our
                    Website;
                  </li>
                  <li>
                    Despite the above terms, we now grant a licence to you to:
                  </li>
                  <ol>
                    <li>
                      create a hyperlink to Our Website for the purpose of
                      promoting an interest common to both of us. You can do
                      this without specific permission. This licence is
                      conditional upon your not portraying us or any product or
                      service in a false, misleading, derogatory, or otherwise
                      offensive manner. You may not use any logo or other
                      proprietary graphic or trademark of ours as part of the
                      link without our express written consent.
                    </li>
                    <li>
                      you may copy the text of any page for your personal use in
                      connection with the purpose of Our Website or a Service we
                      provide.
                    </li>
                  </ol>
                </ol>
                <li>
                  <strong>Storage of data&nbsp;</strong>
                </li>
                <ol>
                  <li>
                    We may, from time to time, set a limit on the number of
                    messages you may send, store, or receive through the
                    Service. We may delete messages in excess of that limit. We
                    shall give you notice of any change to your limit, except in
                    an emergency.
                  </li>
                  <li>
                    We assume no responsibility for the deletion or failure to
                    store or deliver email or other messages.
                  </li>
                  <li>
                    You accept that we cannot be liable to you for any such
                    deletion or failure to deliver to you.
                  </li>
                  <li>
                    We maintain reasonable procedures for general backup of data
                    for our own purposes but we give no warranty that your data
                    will be saved or backed up in any particular circumstances
                    unless we have made specific contractual arrangements with
                    you in writing.
                  </li>
                </ol>
                <li>
                  <strong>Termination</strong>
                </li>
                <ol>
                  <li>
                    This agreement terminates on the expiry of your
                    subscription.
                  </li>
                  <li>
                    You may terminate this agreement at any time, for any
                    reason, with immediate effect. You may terminate the
                    agreement either by sending notice to us by post or email,
                    or by completing the form on Our Website and submitting it.
                    We reserve the right to check the validity of any request to
                    terminate your subscription.
                  </li>
                  <li>
                    We may terminate this agreement at any time, for any reason,
                    with immediate effect by sending you notice to that effect
                    by post or email.
                  </li>
                  <li>
                    Termination by either party shall have the following
                    effects:
                  </li>
                  <ol>
                    <li>your right to use the Services immediately ceases;</li>
                    <li>
                      we are under no obligation to forward any unread or unsent
                      messages to you or any third party;
                    </li>
                  </ol>
                  <li>
                    There shall be no re-imbursement or credit if the Service is
                    terminated due to your violation of the terms of this
                    agreement.
                  </li>
                  <li>
                    We retain the right, at our sole discretion, to terminate
                    any and all parts of the Services provided to you, without
                    refunding to you any fees paid if we decide in our absolute
                    discretion that you have failed to comply with any of the
                    terms of this agreement.&nbsp;
                  </li>
                </ol>
                <li>
                  <strong>Interruption to Services</strong>
                </li>
                <ol>
                  <li>
                    If it is necessary for us to interrupt the Services, we will
                    give you reasonable notice where this is possible and when
                    we judge the down time is such as to justify telling you.
                  </li>
                  <li>
                    You acknowledge that the Services may also be interrupted
                    for many reasons beyond our control.
                  </li>
                  <li>
                    You agree that we are not liable to you for any loss,
                    foreseeable or not, arising from any interruption to the
                    Services.
                  </li>
                </ol>
                <li>
                  <strong>Intellectual Property</strong>
                </li>
              </ol>
              <p>You agree that at all times you will:</p>
              <ol>
                <ol>
                  <li>
                    not do anything which does or might reduce the value of our
                    Intellectual Property or challenge our ownership of it.
                  </li>
                  <li>
                    notify us of any suspected infringement of the Intellectual
                    Property;
                  </li>
                  <li>
                    so far as concerns software provided or made accessible by
                    us to you, you will not:
                  </li>
                  <ol>
                    <li>copy, or make any change to any part of its code;</li>
                    <li>
                      use it in any way not anticipated by this agreement;
                    </li>
                    <li>
                      give access to it to any other person than you, the
                      licensee in this agreement;
                    </li>
                    <li>
                      in any way provide any information about it to any other
                      person or generally.
                    </li>
                  </ol>
                  <li>
                    not use the Intellectual Property except directly in our
                    interest.
                  </li>
                </ol>
                <li>
                  <strong>Disclaimers and limitation of liability</strong>
                </li>
                <ol>
                  <li>
                    The law differs from one country to another. This paragraph
                    applies so far as the applicable law allows.
                  </li>
                  <li>
                    All implied conditions, warranties and terms are excluded
                    from this agreement. If in any jurisdiction an implied
                    condition, warrant or term cannot be excluded, then this sub
                    paragraph shall be deemed to be reduced in effect, only to
                    the extent necessary to release that specific condition,
                    warranty or term.
                  </li>
                  <li>
                    Our Website and our Services are provided &ldquo;as
                    is&rdquo;. We make no representation or warranty that the
                    Service will be:
                  </li>
                  <ol>
                    <li>useful to you;</li>
                    <li>of satisfactory quality;</li>
                    <li>fit for a particular purpose;</li>
                    <li>
                      available or accessible, without interruption, or without
                      error.
                    </li>
                  </ol>
                  <li>
                    We claim no expert knowledge in any subject. We disclaim any
                    obligation or liability to you arising directly or
                    indirectly from information you take from Our Website.
                  </li>
                  <li>
                    We make no representation or warranty and accept no
                    responsibility in law for:
                  </li>
                  <ol>
                    <li>
                      accuracy of any Content or the impression or effect it
                      gives;
                    </li>
                    <li>delivery of Content, material or any message;</li>
                    <li>privacy of any transmission;</li>
                    <li>
                      third party advertisements which are posted on Our Website
                      or through the Services;
                    </li>
                    <li>
                      the conduct, whether online or offline, of any user of Our
                      Website or the Services;
                    </li>
                    <li>
                      failure or malfunction of computer hardware or software or
                      technical equipment or system connected directly or
                      indirectly to your use of the Services;
                    </li>
                    <li>
                      any act or omission of any person or the identity of any
                      person who introduces himself to you through Our Website;
                    </li>
                    <li>
                      any aspect or characteristic of any services advertised on
                      Our Website;
                    </li>
                  </ol>
                  <li>
                    You agree that in any circumstances when we may become
                    liable to you, the limit of our liability is the amount you
                    have paid us in the immediately preceding 12 month period
                    for the Services concerned.
                  </li>
                  <li>
                    Except in the case of death or personal injury, our total
                    liability under this agreement, however it arises, shall not
                    exceed the sum of $1,000. This applies whether your case is
                    based on contract, tort or any other basis in law.
                  </li>
                  <li>
                    We shall not be liable to you for any loss or expense which
                    is:
                  </li>
                  <ol>
                    <li>indirect or consequential loss; or</li>
                    <li>
                      economic loss or other loss of turnover, profits, business
                      or goodwill even if such loss was reasonably foreseeable
                      or we knew you might incur it.
                    </li>
                  </ol>
                  <li>
                    This paragraph (and any other paragraph which excludes or
                    restricts our liability) applies to our directors, officers,
                    employees, subcontractors, agents and affiliated companies
                    as well as to us.
                  </li>
                  <li>
                    If you become aware of any breach of any term of this
                    agreement by any person, please tell us by email
                    info@isimulate.com
                    <em>.</em>We welcome your input but do not guarantee to
                    agree with your judgement.
                  </li>
                </ol>
                <li>
                  <strong>You indemnify us</strong>
                </li>
              </ol>
              <p>
                You agree to indemnify us against all costs, claims and expense
                arising directly or indirectly from:
              </p>
              <ol>
                <ol>
                  <li>your failure to comply with the law of any country;</li>
                  <li>your breach of this agreement;</li>
                  <li>
                    any act, neglect or default by any agent, employee, licensee
                    or customer of yours;
                  </li>
                  <li>
                    a contractual claim arising from your use of the Services
                  </li>
                  <li>
                    a breach of the intellectual property rights of any person;
                  </li>
                </ol>
              </ol>
              <p>
                and for the purpose of this paragraph you agree that the cost of
                our management and technical time is properly recoverable and
                can reasonably be valued at $ 200.00 per hour without further
                proof.
              </p>
              <ol start="20">
                <li>
                  <strong>Miscellaneous matters</strong>
                </li>
                <ol>
                  <li>
                    The schedules, if any, to this agreement are part of the
                    agreement and have the same force and effect.
                  </li>
                  <li>
                    If any term or provision of this agreement is at any time
                    held by any jurisdiction to be void, invalid or
                    unenforceable, then it shall be treated as changed or
                    reduced, only to the extent minimally necessary to bring it
                    within the laws of that jurisdiction and to prevent it from
                    being void and it shall be binding in that changed or
                    reduced form. Subject to that, each provision shall be
                    interpreted as severable and shall not in any way affect any
                    other of these terms.
                  </li>
                  <li>
                    The rights and obligations of the parties set out in this
                    agreement shall pass to any permitted successor in title.
                  </li>
                  <li>
                    If you are in breach of any term of this agreement, we may:
                  </li>
                  <ol>
                    <li>
                      publish all text and Content relating to the claimed
                      breach, including your name and email address and all
                      correspondence between us and our respective advisers; and
                      you now irrevocably give your consent to such publication.
                    </li>
                    <li>
                      terminate your account and refuse access to Our Website;
                    </li>
                    <li>
                      remove or edit Content, or cancel any order at our
                      discretion;
                    </li>
                    <li>issue a claim in any court.</li>
                  </ol>
                  <li>
                    Any obligation in this agreement intended to continue to
                    have effect after termination or completion shall so
                    continue.
                  </li>
                  <li>
                    No failure or delay by any party to exercise any right,
                    power or remedy will operate as a waiver of it nor indicate
                    any intention to reduce that or any other right in the
                    future.
                  </li>
                  <li>
                    You agree that we may disclose your information including
                    assigned IP numbers, account history, account use, etc to
                    any judicial or proper legal authority who makes a written
                    request without further consent or notification to you.
                  </li>
                  <li>
                    Any communication to be served on either party by the other
                    shall be delivered by hand or sent by express post or
                    recorded delivery.
                  </li>
                </ol>
              </ol>
              <table cellspacing="0" cellpadding="0">
                <tbody>
                  <tr>
                    <td valign="top">
                      <p>It shall be deemed to have been delivered:</p>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <p>if delivered by hand: on the day of delivery;</p>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <p>
                        if sent by post to the correct address: within 72 hours
                        of posting;
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <p>&nbsp;</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <ol>
                <ol start="9">
                  <li>
                    In the event of a dispute between the parties to this
                    agreement, then they undertake to attempt to settle the
                    dispute by engaging in good faith with the other in a
                    process of mediation before commencing arbitration or
                    litigation.
                  </li>
                  <li>
                    So far as the law permits, and unless otherwise stated, this
                    agreement does not give any right to any third party.
                  </li>
                  <li>
                    Neither party shall be liable for any failure or delay in
                    performance of this agreement which is caused by
                    circumstances beyond its reasonable control, including any
                    labour dispute between a party and its employees.
                  </li>
                  <li>
                    In the event of any conflict between any term of this
                    agreement and the provisions of the constitution of a
                    limited company or any comparable document intended to
                    regulate any other corporate or collective body, then the
                    terms of this agreement shall prevail.
                  </li>
                  <li>
                    The validity, construction and performance of this agreement
                    shall be governed by the law of the State of Australian
                    Capital Territory and you agree that any dispute arising
                    from it shall be litigated only in that State.
                  </li>
                </ol>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
export default {
  name: "MyMedia",
  components: {
    UserMenu,
  },
};
</script>

<style scoped>
.terms {
  counter-reset: heading;
}
li > strong {
  counter-increment: heading;
}

ol > ol {
  counter-reset: item;
}
li {
  display: block;
}

li > strong:before {
  content: counters(heading, ".") ". ";
}

ol > ol > li:before {
  content: counters(heading, ".") "." counters(item, ".") ". ";
  counter-increment: item;
  font-weight: bold;
}
ol > ol > li {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
